import { render, staticRenderFns } from "./UWHeader.vue?vue&type=template&id=5bcc2a18&scoped=true&"
import script from "./UWHeader.vue?vue&type=script&lang=js&"
export * from "./UWHeader.vue?vue&type=script&lang=js&"
import style0 from "./UWHeader.vue?vue&type=style&index=0&id=5bcc2a18&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bcc2a18",
  null
  
)

export default component.exports